import { ParamsResponse } from 'interfaces/global.types';
import request from './request';

const currencyService = {
  getAll: (params?: ParamsResponse) => request.get('currency/', { params }),
  getID: (id?: number) => request.get(`currency/${id}/`),
  delete: (id?: number) => request.delete(`currency/${id}/`),
  create: (data?: any) => request.post('currency/', data),
  update: (id?: number, data?: any) => request.patch(`currency/${id}/`, data),
};

export default currencyService;
